export function withEnvVar(name: string, value: string) {
    const originalValue = process.env[name];
    beforeAll(() => {
        process.env[name] = value;
    });
    afterAll(() => {
        process.env[name] = originalValue;
    });
}
